<template>
  <modal 
    name="add-client-via-template-modal" 
    :pivotY="0.2"
    :width="'620px'"
    height="auto"
    @before-open="beforeOpen">

    <div class="modal-header">
      <div class="modal-title">
        Adding a client via template
      </div>

      <a href="#"
        @click.prevent="$modal.hide('add-client-via-template-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>
    
    <div class="modal-body">
      <div class="label-standard">Please select a client template below</div>
      <div class="form-line">
        <select v-model="templateId" class="select-standard h-10">
          <option :value="null">Please select a client template</option>
          <template v-for="(template, index) in templates">
            <option :value="template.id">{{ template.name }}</option>
          </template>
        </select>
      </div>

      <div v-if="error !== null" class="text-red-600 mt-1 text-sm">{{ error }}</div>

      <div class="mt-6">
        <SubmitButton :onClick="submit" :loading="loading" label="Create" />
      </div>
    </div>
  </modal>
</template>

<script>
  import SubmitButton from '@/shared/components/form/SubmitButton'

  export default {

    components : {
      SubmitButton,
    },

    data() {
      return {
        loading   : false,
        templates : null,
        templateId: null,
        error     : null
      }
    },

    methods : {
      beforeOpen(event) {
        this.templateId = null
        this.error      = null

        this.apiGet({
          type : 'client'
        }, 'template/list', (templates) => {
          this.hideLoader()
          this.templates = templates
        })
      },

      submit() {
        let valid  = true
        this.error = null

        if(this.templateId == null) {
          this.error = "Please select a template"
          valid = false
        }

        if(valid) {
          this.loading = true
          this.apiPost({
            templateId : this.templateId
          }, 'client/create-via-template', (data) => {
            
            this.$modal.hide('add-client-via-template-modal')

            this.$modal.show('client-source-modal', {
              client     : data.client,
              applicantId: data.applicant.id
            })            
          })
        }
      }
    }
  }
</script>